<template>
	<div v-loading="recordsLoading" class="record-list">
		<template v-if="diagnosisRecordList.length">
			<div v-for="(item, index) in diagnosisRecordList" :key="index" class="record-item">
				<div class="record-item__name">
					<svg-icon icon-class="enterprise" class="record-item__name-icon"></svg-icon>
					{{ item.sslName }}
				</div>
				<div class="record-item__desc">
					<label>资质类别</label>
					<span>{{ item.diagnosisContentName }}</span>
				</div>
				<div class="record-item__time">
					<label>诊断时间</label>
					<span>{{ item.createTime | formatDate }}</span>
				</div>
				<div class="record-item__time">
					<label>报告状态</label>
					<span>{{ getGenerateStateName(item.generateState) }}</span>
				</div>
				<div v-if="isGenerateUnDown(item.generateState) || isGenerateDownning(item.generateState)" class="record-item__time">
					<label>预计生成时间</label>
					<span>{{ item.generatePlanTime | formatDate }}</span>
				</div>
				<div v-if="isGenerateDowned(item.generateState)" class="record-item__time">
					<label>生成时间</label>
					<span>{{ item.generateStartTime | formatDate }}</span>
				</div>
				<div v-if="!isResultUnDown(item.generateState)" class="record-item__tools">
					<el-button type="primary" @click="handleViewDiagDetail(item)">诊断结果</el-button>
					<el-button
						v-if="isGenerateUnDown(item.generateState)"
						:disabled="generateLoading || isManuallyReview(item.generateState)"
						type="info"
						@click="handleGenerateReport(item.id)">
						生成报告
					</el-button>
					<el-button v-else :disabled="!isGenerateDowned(item.generateState)" type="success" @click="handleDownLoadReport(item)">
						下载报告
					</el-button>
				</div>
			</div>
		</template>
		<!-- 数据为空 -->
		<empty-content v-else></empty-content>

		<!-- 分页器 -->
		<jr-pagination
			v-if="moreRecords && pageOptions.total > pageOptions.limit"
			:limit="pageOptions.limit"
			:page.sync="pageOptions.page"
			:total="pageOptions.total"
			layout="prev, pager, next"
			prev-text="上一页"
			next-text="下一页"
			@change="handlePaginationChange"></jr-pagination>

		<!-- 未绑定企业遮罩层 -->
		<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="payVisible = false">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<!-- 因这里需要从vip升级为svip故这里传递svip -->
				<payment-dialog active-vip-type="svip" @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import JrPagination from '@/components/Pagination'
	import NonbindEnterprise from '@/components/NonBind/nonbindEnterprise'
	import { ENUM_GGENERATE_REPORT_STATE, GGENERATE_REPORT_STATE } from '@/enum/index'
	import { mapGetters } from 'vuex'
	import { getToken } from '@/utils/auth'
	import { getDiagnosisRecordPage, generateDiagnosticReport, downloadFileRecord } from '@/api/certTreasure/diagnosis'

	// 不同类型的诊断记录
	export default {
		name: 'DiagnosticRecords',
		components: {
			JrDialog,
			PaymentDialog,
			JrPagination,
			NonbindEnterprise
		},
		props: {
			/**
			 * 类型，传递不同发类型编码。
			 * 首次申请：SCSQ
			 * 升级：SJ
			 * 增项：ZX
			 * 延续：YX
			 * 重新核定：CXHD
			 */
			mattersType: {
				type: String,
				required: true,
				default: ''
			},
			// 是否展示更多记录
			moreRecords: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				// 诊断结果记录
				recordsLoading: false,
				// 诊断结果记录
				diagnosisRecordList: [],
				pageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},
				// 诊断报告生成
				generateLoading: false
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'companyId', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip'])
		},
		watch: {},
		created() {},
		mounted() {
			// 绑定企业才能查询诊断记录
			if (this.isHasCompany) {
				this.handleQueryDiagnosisRecordList()
			}
		},
		methods: {
			// 查询诊断记录
			handleQueryDiagnosisRecordList() {
				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					mattersType: this.mattersType
				}

				this.recordsLoading = true
				getDiagnosisRecordPage(params)
					.then(response => {
						const { data } = response

						if (data.records && data.records.length > 0) {
							this.diagnosisRecordList = data.records
							this.pageOptions.total = data.total
						} else {
							this.diagnosisRecordList = []
							this.pageOptions.total = 0
						}

						this.recordsLoading = false
					})
					.catch(error => {
						this.recordsLoading = false
					})
			},

			// 分页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.handleQueryDiagnosisRecordList()
			},

			// 获取报告生成状态名称
			getGenerateStateName(state) {
				return ENUM_GGENERATE_REPORT_STATE[state] || ''
			},

			// 诊断结果未生成
			isResultUnDown(state) {
				return Number(state) === GGENERATE_REPORT_STATE.RESULT_GENERATING
			},

			// 报告未生成
			isGenerateUnDown(state) {
				return Number(state) === GGENERATE_REPORT_STATE.UNGENERATED || Number(state) === GGENERATE_REPORT_STATE.MANUALLY_REVIEW
			},
			// 建筑业人工审核
			isManuallyReview(state) {
				return Number(state) === GGENERATE_REPORT_STATE.MANUALLY_REVIEW
			},
			// 报告生成中
			isGenerateDownning(state) {
				return Number(state) === GGENERATE_REPORT_STATE.GENERATEDING
			},

			// 报告已生成
			isGenerateDowned(state) {
				return Number(state) === GGENERATE_REPORT_STATE.GENERATED
			},

			// 生成诊断报告
			handleGenerateReport(recordId) {
				// // 诊断报告生成需要判断是否为超级会员svip
				// if (!this.isSVip) {
				// 	this.$modal.msgWarning('您尚未开通超级会员，请开通超级会员后进行操作')
				// 	this.payVisible = true
				// 	return
				// }

				const params = {
					recordId: recordId
				}

				this.generateLoading = true

				generateDiagnosticReport(params).then(response => {
					const { code } = response
					this.generateLoading = false
					if (code === 200) {
						this.$modal.msgSuccess('操作成功')
						this.handleQueryDiagnosisRecordList()
					}
				})
			},

			// 下载诊断报告
			handleDownLoadReport(item) {
				// // 诊断报告下载需要判断是否为超级会员svip
				// if (!this.isSVip) {
				// 	this.$modal.msgWarning('您尚未开通超级会员，请开通超级会员后进行操作')
				// 	this.payVisible = true
				// 	return
				// }

				// 判断报告是否已经生成成功
				if (!this.isGenerateDowned(item.generateState)) {
					return
				}

				window.open(downloadFileRecord({ recordId: item.id, companyId: this.companyId, InternetToken: getToken() }), '_blank')
			},

			// 查看诊断结果
			handleViewDiagDetail(item) {
				this.$router.push({
					path: '/qualification/diagnosis-result',
					query: {
						recordId: item.id,
						ssl: item.sslCode
					}
				})
			},

			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.record-list {
		position: relative;
		.record-item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 20px;
			background: #f5f9fb;
			border-radius: 6px;
			transition: all 0.3s ease;
			position: relative;
			overflow: hidden;

			/* 过渡动画 */
			animation: slideIn 0.5s ease-out forwards;
			opacity: 0;
			transform: translateX(20px);

			@for $i from 1 through 100 {
				&:nth-child(#{$i}) {
					animation-delay: #{$i * 0.1}s;
				}
			}

			& + .record-item {
				margin-top: 20px;
			}

			&:hover {
				transform: translateY(5px);
				box-shadow: 0 4px 12px rgba(19, 116, 235, 0.1);

				.record-item__name {
					color: #1374eb;
				}
			}

			.record-item__name {
				width: 290px; // 固定宽度
				flex: 0 0 290px; // 不伸缩，保持固定宽度
				font-size: 18px;
				font-weight: bold;
				color: #333;

				.record-item__name-icon {
					font-size: 24px;
					color: #1374eb;
					margin-right: 5px;
				}
			}

			.record-item__desc,
			.record-item__time {
				display: flex;
				align-items: left;
				flex-direction: column;
				font-size: 16px;

				label {
					color: #999;
				}

				span {
					flex: 1;
					word-break: break-all; // 允许在任意字符间断行
					// display: -webkit-box;
					// -webkit-line-clamp: 2; // 最多显示两行
					// -webkit-box-orient: vertical;
					// overflow: hidden;
					// text-overflow: ellipsis;
				}
			}

			.record-item__desc {
				width: 350px;
				padding-right: 10px; // 添加右侧间距
			}

			.record-item__time {
				width: 110px;
				padding-right: 10px; // 添加右侧间距
			}

			.record-item__tools {
				text-align: center; // 按钮居中
				.el-button {
					padding: 8px 15px;
					font-size: 16px;
					font-weight: normal;
					border: none;
					border-radius: 15px;
				}
			}
		}
	}
</style>
